// frontend/app/quizNormalize.js

// exactly your current behavior extracted to a helper
export const normalizeQuizQuestions = (rawQuiz = []) => {
  return (rawQuiz || []).map((question) => ({
    ...question,
    options: {
      correct_answer: question?.options?.correct_answer,
      option1: question?.options?.option1,
      option2: question?.options?.option2,
      option3: question?.options?.option3,
      option4: question?.options?.option4,
    },
    hints: {
      hint1: question?.hints?.hint1,
      hint2: question?.hints?.hint2,
    },
    solution: question?.solution,
  }));
};
